import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const PLACE_FEEDBACK_KEY = 'geo.placeFeedback';
export const PLACE_FEEDBACK_BOUNDS = { maxPendingPerRider: { min: 1, max: 100 } };
export const DEFAULT_PLACE_FEEDBACK = { maxPendingPerRider: 10 };
export const STRICT_PLACE_FEEDBACK = { maxPendingPerRider: PLACE_FEEDBACK_BOUNDS.maxPendingPerRider.min };
export const PLACE_FEEDBACK_POLICY_REASON_CODES = ['PLACE_FEEDBACK_POLICY_GOVERNED', 'PLACE_FEEDBACK_POLICY_DEFAULT', 'PLACE_FEEDBACK_POLICY_INVALID'];
export function placeFeedbackPolicyIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['maxPendingPerRider']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = PLACE_FEEDBACK_BOUNDS.maxPendingPerRider;
    if (!intWithin(v.maxPendingPerRider, b.min, b.max))
        return 'INVALID_MAX_PENDING_PER_RIDER';
    return undefined;
}
export const PLACE_FEEDBACK_SPEC = {
    key: PLACE_FEEDBACK_KEY,
    issue: placeFeedbackPolicyIssue,
    copy: (v) => ({ maxPendingPerRider: v.maxPendingPerRider }),
    defaultValue: DEFAULT_PLACE_FEEDBACK,
    strictValue: STRICT_PLACE_FEEDBACK,
    reasonPrefix: 'PLACE_FEEDBACK_POLICY',
};
export function placeFeedbackPolicySetting(input) {
    return marketRuleSetting(PLACE_FEEDBACK_SPEC, input);
}
export function resolvePlaceFeedbackPolicy(settings, marketId, at, regionCode) {
    return resolveMarketRule(PLACE_FEEDBACK_SPEC, settings, marketId, at, regionCode);
}
//# sourceMappingURL=place-feedback-policy.js.map